import { LayoutWithNothing } from '~/components/LayoutWithNothing'
import { CreateCampaignProvider } from '~/contexts/CreateCampaignContext'
import { Create } from '~/features/campaign_create/Create'
import { CampaignCreateThemeProvider } from '~/features/campaign_create/CampaignCreateThemeProvider'
import { OldIOSAlert } from '~/features/campaign_create/OldIOSAlert'
import { RequireLineConnectionDialog } from '~/features/campaign_create/RequireLineConnectionDialog'
import { useConfirmOnLeaveDialog } from '~/lib/hooks/useConfirmOnLeaveDialog'

export type OptionalQuery = {
  category: string
}

const CampaignCreate = () => {
  const { confirmDialog } = useConfirmOnLeaveDialog()

  return (
    <CampaignCreateThemeProvider>
      <CreateCampaignProvider>
        <OldIOSAlert />
        <Create />
        <RequireLineConnectionDialog />
        {confirmDialog}
      </CreateCampaignProvider>
    </CampaignCreateThemeProvider>
  )
}

CampaignCreate.Layout = LayoutWithNothing

export default CampaignCreate
